export default "__VITE_ASSET__DE4WER60__"